@let globalKpi = dashboardStore.plusGlobalKpi();
<div
  class="grid grid-cols-1 md:grid-cols-3 mt-4 font-edenred"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
  id="dashboard__plus-total-performance"
>
  <er-performance-item
    [value]="globalKpi?.transactions || 0"
    [percent]="globalKpi?.performance?.transactions_performance || 0"
    [comparedWith]="dashboardStore.selectedTimePeriod().comparedWith"
    valueName="{{ i18CmpTotalPerformanceItems + '.transactions' | transloco }}"
    upDirectionLabel="{{ i18CmpDirectionLabel + '.up' | transloco }}"
    downDirectionLabel="{{ i18CmpDirectionLabel + '.down' | transloco }}"
    id="dashboard__total-performance-1"
  ></er-performance-item>
  <er-performance-item
    [value]="globalKpi?.paymentAmount || 0"
    [percent]="globalKpi?.performance?.payment_amount_performance || 0"
    [comparedWith]="dashboardStore.selectedTimePeriod().comparedWith!"
    currency="€"
    valueName="{{
      i18CmpTotalPerformanceItems + '.payment_amount' | transloco
    }}"
    upDirectionLabel="{{ i18CmpDirectionLabel + '.up' | transloco }}"
    downDirectionLabel="{{ i18CmpDirectionLabel + '.down' | transloco }}"
    id="dashboard__total-performance-2"
  ></er-performance-item>
  <er-performance-item
    [value]="globalKpi?.uniqueClients || 0"
    [percent]="globalKpi?.performance?.unique_clients_performance || 0"
    [comparedWith]="dashboardStore.selectedTimePeriod().comparedWith!"
    valueName="{{ i18CmpTotalPerformanceItems + '.clients' | transloco }}"
    upDirectionLabel="{{ i18CmpDirectionLabel + '.up' | transloco }}"
    downDirectionLabel="{{ i18CmpDirectionLabel + '.down' | transloco }}"
    id="dashboard__total-performance-3"
  ></er-performance-item>
</div>
